import React from "react";
import { Link } from "react-router-dom";
import "./newspaper/newspaper.css";

// Shown for any URL that has no route (instead of an empty page)
function NotFound() {
  return (
    <main id="main" className="container submit-page">
      <div className="empty-state">
        <span>↳</span>
        <h3>ไม่พบหน้าที่ต้องการ</h3>
        <p>ลิงก์อาจไม่ถูกต้องหรือหน้านี้ถูกย้ายแล้ว</p>
        <Link className="text-link" to="/">
          กลับหน้าแรก{" "}
          <span>→</span>
        </Link>
      </div>
    </main>
  );
}

export default NotFound;
